import React from 'react'

import type { LayoutColumn } from '@components/layout/types'

export const ImageContext = React.createContext<{
  cols: LayoutColumn
}>({
  cols: 12,
})
